function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "cubies_negentien",
  d: "M29 32H3a3 3 0 0 1-3-3V0h2l4 4h20l4-4h2v29a3 3 0 0 1-3 3z",
  fill: "#f2c99e"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cubies_twintig",
  d: "M27 32H3a3 3 0 0 1-3-3V0l4 4h22l4-4v29a3 3 0 0 1-3 3z",
  fill: "#f9e0bd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cubies_een",
  d: "M20 8a2 2 0 1 1 .001 3.999A2 2 0 0 1 20 8zM8 10a2 2 0 1 0 3.999.001A2 2 0 0 0 8 10z",
  fill: "#4c4842"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cubies_twaalf",
  d: "M20.5 9a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zM10 9.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0z",
  fill: "#fff2df"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cubies_tweeentwintig",
  d: "M17.354 17.646L15.5 15.793v-1.058c.592-.343 1.5-.987 1.5-1.735 0-1.105-.895-1-2-1s-2-.105-2 1c0 .748.908 1.392 1.5 1.735v1.058l-1.854 1.854a.5.5 0 0 0 .708.707L15 16.707l1.646 1.646a.5.5 0 1 0 .708-.707z",
  fill: "#d97360"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cubies_achtien",
  d: "M32 9h-2V7h2v2zm0 2h-2v2h2v-2zm0 4h-2v2h2v-2zm0 4h-2v2h2v-2zm0 4h-2v2h2v-2zm0 4h-2v2h2v-2z",
  fill: "#edb57e"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cubies_negentien",
  d: "M4 12a1 1 0 0 1-1 1H0v-2h3a1 1 0 0 1 1 1zm-1 3H0v2h3a1 1 0 0 0 0-2zm0 4H0v2h3a1 1 0 0 0 0-2zm0 4H0v2h3a1 1 0 0 0 0-2zm0 4H0v2h3a1 1 0 0 0 0-2zM3 7H0v2h3a1 1 0 0 0 0-2zm23 9a1 1 0 0 0 1 1h3v-2h-3a1 1 0 0 0-1 1zm0-4a1 1 0 0 0 1 1h3v-2h-3a1 1 0 0 0-1 1zm1-5a1 1 0 0 0 0 2h3V7h-3zm-1 17a1 1 0 0 0 1 1h3v-2h-3a1 1 0 0 0-1 1zm0 4a1 1 0 0 0 1 1h3v-2h-3a1 1 0 0 0-1 1zm0-8a1 1 0 0 0 1 1h3v-2h-3a1 1 0 0 0-1 1z",
  fill: "#f2c99e"
});

var SvgCat = function SvgCat(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default __webpack_public_path__ + "static/media/cat.70dfa41b.svg";
export { SvgCat as ReactComponent };